export default {
  SUCCESSFUL_ANSWER: 1,
  HINT_ANSWER: 2,
  FAIL_ANSWER: 3,
  NO_ANSWER: 4,
};


// WEBPACK FOOTER //
// ./src/modules/randomRotation/Constants.js